import React from 'react';

export const GoogleSheetIcon = ({ size }) => {
    return (
        <svg
            fill="#43A047"
            height={size}
            width={size}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 204.376 204.376"
            xmlSpace="preserve"
        >
            <path d="M171.247 204.376a4.5 4.5 0 004.5-4.5V61.35h-51.744c-7.502 0-13.605-6.107-13.605-13.614V0H33.13a4.5 4.5 0 00-4.5 4.5v195.376a4.5 4.5 0 004.5 4.5h138.117zM52.891 87.627h99.717v80H52.891v-80zm53.858 56.333h37.858v15.667h-37.858V143.96zm-45.858-24.666h37.858v16.666H60.891v-16.666zm0 24.666h37.858v15.667H60.891V143.96zm45.858-48.333h37.858v15.667h-37.858V95.627zm0 23.667h37.858v16.666h-37.858v-16.666zM60.891 95.627h37.858v15.667H60.891V95.627zm59.506-47.891v-37.34L164.2 51.35h-40.197a3.614 3.614 0 01-3.606-3.614z" />
        </svg>
    );
};
